import axios from 'ps-components/lib/apiClient';
import { ReportParams } from '../../components/Reports/types';
import { useMutation } from 'react-query';
import addAlert from 'ps-components/AlertToast/addAlert';

export const useSaveReport = () => {
    const saveReport = async (params: ReportParams) => {
        const response = await axios.apiPost('/api/report-writer/report/save', params)
        if (!response.data.success) throw new Error(response.data.save_message || 'Error saving report')
        return response.data
    }

    const mutation = useMutation(saveReport, {
        onError: (error) => {
            const errorMessage = error instanceof Error ? error.message : 'Error saving report'
            addAlert(errorMessage, 'warning');
        }
    })
    return mutation
}